<template>
  <div class="main-container">
      <!-- Author: Vaishnavi
      Date: 10/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />

  <div>
      <tl-header type="h1">
          <div class="main-header">Manage Employee Documents</div>
       </tl-header>
  </div>

  <div class="margintop-16">
    <manageEmployeeDocuments />
      <!-- <tl-tabs :tabs="tabs">
        <tl-tab>
          <manage-documents/>
        </tl-tab>
        <tl-tab>
          <document-directory/>
        </tl-tab>
      </tl-tabs> -->
  </div>  
  </div>
</template>
<script>
//import manageDocuments from "./manageDocuments.vue";
//import documentDirectory from "./documentDirectory.vue";
import manageEmployeeDocuments from "./manageEmployeeDocuments";

export default {
  name: "Documents",
  components: {
    //manageDocuments,
    //documentDirectory,
    manageEmployeeDocuments
  },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Company",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Manage Employee Documents",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/documents`
              }
            ],
      tabs: [
        {
          header: "Manage Documents"
        },
        {
          header: "Document Directory"
        }
      ]
    };
  },
  methods: {
  routeToMainStep(main_step_name) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/${main_step_name}`
      });
    },
    routeToSubStep(sub_step_name) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/${sub_step_name}`
      });
    },
    createDocuments(){

    }
  }
};
</script>
<style scoped lang="scss">
@import "@/scss/components/margins.scss"; 
  .margin-top-16p{
    margin-top: 1.6%;
  }
  .margin-top-18 {
    margin-top: 18px;
  }
  .main-header {
    color: #6d6d6d;
    margin-top: 25px;
    font-size: 16px;
  }

</style>
